import Modal from "../ui/Modal";

const DescriptionModal = ({openModalDescription, brandName, serviceName, parsedDescription, setOpenModalDescription, setSelectedService}) => {
  return (
    <Modal
      activeModal={openModalDescription}
      onClose={() => {setOpenModalDescription(false); setSelectedService({})}}
      title="Descripción del servicio"
      className="max-w-6xl"
      centered
    >
      <div className="text-xs text-gray-800 font-semibold text-lg mb-2">
        <span className="font-bold">Cliente: </span>
        <span className="font-light">{brandName}</span>
      </div>

      <div className="text-xs text-gray-800 font-semibold text-lg mb-4">
        <span className="font-bold">Servicio: </span>
        <span className="font-light">{serviceName}</span>
      </div>

      <div className="p-3 shadow border rounded w-full">
        <div className="overflow-x-auto">
          <table className="min-w-full border border-gray-300 text-sm text-slate-600 text-xs">
            <thead className="bg-gray-100">
              <tr>
                <th className="px-4 py-2 border border-gray-300 text-left">Servicio</th>
                <th className="px-4 py-2 border border-gray-300 text-left">Descripción</th>
              </tr>
            </thead>
            <tbody>
              {parsedDescription.map((service, index) => (
                <tr key={index} className={index % 2 === 0 ? "bg-white" : "bg-gray-50"}>
                  <td className="px-4 py-2 border border-gray-300">{service.key}</td>
                  <td className="px-4 py-2 border border-gray-300">{service.value}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </Modal>
  )
}

export default DescriptionModal